export default "__VITE_ASSET__0f2639fe__"